/* eslint-disable react/jsx-key */
import React, { useState } from 'react'
import { strCol, intCol, numCol } from '@integec/grid-tools/lib/cols'
import {
  modifierCol,
  modifiedDateCol,
  utilityHeader,
  unitHeader,
} from 'core/HeaderColTypeProps'
import { getApiTargetInfo, UtilityUnitSelection } from 'core'
import { connect } from 'react-redux'
import {
  getPercentOwnershipInfo,
  postPercentOwnershipInfo,
  deletePercentOwnershipInfo,
  // getUtilityUnitMap,
} from 'api/pgads.js'
import { getUtilityNameMap, getUnitNameMap } from 'core/selectors'

import CommonScreen from './CommonScreen'
import { Button, InputNumber, DatePicker } from 'antd'
import styled from 'styled-components'
import moment from 'moment'

const { MonthPicker } = DatePicker

const TableTD = styled.td`
  text-align: end;
`

const retrieveTask = apiTargetInfo => getPercentOwnershipInfo(apiTargetInfo)

const modifyTask = apiTargetInfo => data =>
  postPercentOwnershipInfo(apiTargetInfo)(data)

const deleteTask = apiTargetInfo => data =>
  deletePercentOwnershipInfo(apiTargetInfo)(data)

/* const monthOption = R.range(1, 13).map(i => ({
  key: i + '',
  value: i + '',
  text: i + '',
})) */

const headers = [
  intCol({
    ident: 'effectiveYear',
    display: 'Effective Year',
    isKey: true,
  }),
  strCol({
    ident: 'effectiveMonth',
    display: 'Effective Month',
    isKey: true,
  }),
  utilityHeader,
  unitHeader,
  numCol({
    ident: 'percentOwned',
    display: 'Percent Owned',
  }),
  numCol({
    ident: 'deregulatedPercent',
    display: 'Deregulated Percent',
  }),
  numCol({
    ident: 'regulatedPercent',
    display: 'Regulated Percent',
  }),
  modifierCol,
  modifiedDateCol,
]

const title = 'Percent Ownership'

const PercentOwnership = props => {
  const [insertEvent, setInsertEvent] = useState(false)

  // const [utilityUnitMap, setUtilityUnitMap] = useState()

  /* useEffect(_ => {
    getUtilityUnitMap(props.apiTargetInfo).fork(_, utilUnitMap =>
      setUtilityUnitMap(utilUnitMap)
    )
  }, []) */

  const { utilityNameMap, unitNameMap } = props

  // const setData = data => {
  //   setInsertData({ ...insertData, ...data })
  // }

  // const onCancel = () => {
  //   setInsertEvent(false)
  //   setInsertData({})
  // }

  // const onAdd = ({ hide, retrieve }) => {
  //   const validate = validateData()
  //   if (validate)
  //     modifyTask(props.apiTargetInfo)([insertData]).fork(setErr, _ => {
  //       message.info('Data Saved')
  //       setInsertEvent(!hide)
  //       setInsertData({})
  //       retrieve && retrieve()
  //     })
  // }

  // const validateData = () => {
  //   const { effectiveYear, effectiveMonth, utility, unit } = insertData

  //   if (!effectiveYear || !effectiveMonth) message.error('Please, Select Year-Month to Save')
  //   else if (!utility || !unit) message.error('Please, Select Utility/Unit to Save')
  //   else return true
  //   return false
  // }

  const insertComp = ({ insertData, setInsertData, onAdd, onCancel }) => {
    return (
      <table
        style={{
          width: '100%',
          borderSpacing: '5px',
          borderCollapse: 'inherit',
        }}
      >
        <tbody>
          <tr>
            <TableTD>Effective Date :</TableTD>
            <td style={{ minWidth: '150px' }}>
              <MonthPicker
                className="effectiveDate"
                format="MMMM-YYYY"
                style={{ width: '100%' }}
                onChange={date =>
                  setInsertData({
                    ...insertData,
                    effectiveYear: moment(date).format('YYYY'),
                    effectiveMonth: moment(date).format('M'),
                  })
                }
                placeholder="Effective Date"
              />
            </td>
            <TableTD>Utility/Unit :</TableTD>
            <td colSpan={3}>
              <UtilityUnitSelection
                className="utilityUnit"
                utility={insertData.utility}
                unit={insertData.unit}
                style={{ width: '100%' }}
                onUnitChange={value => {
                  setInsertData({
                    ...insertData,
                    utility: value[0],
                    unit: value[1],
                  })
                }}
              />
            </td>
            <td />
          </tr>
          <tr>
            <TableTD>Percent Owned :</TableTD>
            <td style={{ minWidth: '150px' }}>
              <InputNumber
                className="percentOwned"
                style={{ width: '100%' }}
                key="percentOwned"
                placeholder="Percent Owned"
                onChange={value =>
                  setInsertData({ ...insertData, percentOwned: value })
                }
              />
            </td>
            <TableTD>Deregulated Percent :</TableTD>
            <td style={{ minWidth: '150px' }}>
              <InputNumber
                className="deregulatedPercent"
                style={{ width: '100%' }}
                key="deregulatedPercent"
                placeholder="Deregulated Percent"
                onChange={value =>
                  setInsertData({ ...insertData, deregulatedPercent: value })
                }
              />
            </td>
            <TableTD>Regulated Percent :</TableTD>
            <td style={{ minWidth: '150px' }}>
              <InputNumber
                className="regulatedPercent"
                style={{ width: '100%' }}
                key="regulatedPercent"
                placeholder="Regulated Percen"
                onChange={value =>
                  setInsertData({ ...insertData, regulatedPercent: value })
                }
              />
            </td>
            <td>
              <Button type="primary" onClick={() => onAdd(true)}>
                Add
              </Button>
            </td>
            <td>
              <Button type="primary" onClick={() => onAdd(false)}>
                Add & Hide
              </Button>
            </td>
            <td>
              <Button type="danger" onClick={onCancel}>
                Cancel
              </Button>
            </td>
          </tr>
        </tbody>
      </table>
    )
  }

  const headerWithFormatter = headers.map(header =>
    header.ident === 'utility'
      ? {
          ...header,
          // ...toSelectionColProps(utilityNameMap),
          dataFormatter: ({ value }) => utilityNameMap[value] || value,
          sortIndexGetter: ({ rowData }) =>
            utilityNameMap[rowData.utility] || rowData.utility,
        }
      : header.ident === 'unit'
      ? {
          ...header,
          // choices: [],
          // dataGetter: this.generateDataGetter,
          dataFormatter: ({ value }) => unitNameMap[value] || value,
          sortIndexGetter: ({ rowData }) =>
            unitNameMap[rowData.unit] || rowData.unit,
        }
      : /*: header.ident === 'effectiveMonth'
        ? {
            ...header,
            choices: monthOption,
          } */
        header
  )

  return [
    <CommonScreen
      title={title}
      header={headerWithFormatter}
      saveTask={modifyTask}
      retrieveTask={retrieveTask}
      deleteTask={deleteTask}
      altBy={d => d.unit}
      autoRetrieve
      // sortOptions={[
      //   { ident: 'utility', display: 'Utility', sortOrder: 'asc' },
      //   { ident: 'unit', display: 'Unit', sortOrder: 'asc' },
      // ]}
      insertComp={insertEvent && insertComp}
      insertCompHeight={130}
      onInsertEvent={b => setInsertEvent(b)}
      headerRowHeight={60}
    />,
  ]
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
  utilityNameMap: getUtilityNameMap(state),
  unitNameMap: getUnitNameMap(state),
})

export default connect(mapStateToProps)(PercentOwnership)
